/* Simple stroke icons — geometry only, coloured by the caller. */

const PATHS = {
  cart:   <><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.2 12.2a1.5 1.5 0 0 0 1.5 1.2h8.3a1.5 1.5 0 0 0 1.5-1.2L21 7H6"/></>,
  grid:   <><rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="3" width="7" height="7" rx="2"/><rect x="3" y="14" width="7" height="7" rx="2"/><rect x="14" y="14" width="7" height="7" rx="2"/></>,
  book:   <><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z"/><path d="M4 20.5A2.5 2.5 0 0 1 6.5 18H20"/></>,
  note:   <><path d="M5 3h9l5 5v13H5z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/></>,
  chart:  <><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></>,
  box:    <><path d="M3 7.5 12 3l9 4.5v9L12 21 3 16.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/></>,
  calendar:<><rect x="3" y="4.5" width="18" height="16" rx="2.5"/><path d="M3 9h18M8 2.5v4M16 2.5v4"/></>,
  menu:   <><path d="M4 6.5h16M4 12h16M4 17.5h16"/></>,
  plus:   <><path d="M12 5v14M5 12h14"/></>,
  minus:  <><path d="M5 12h14"/></>,
  check:  <><path d="M4 12.5 9.5 18 20 6"/></>,
  x:      <><path d="M6 6l12 12M18 6 6 18"/></>,
  lock:   <><rect x="4.5" y="10.5" width="15" height="10" rx="2.5"/><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5"/></>,
  gear:   <><circle cx="12" cy="12" r="3.2"/><path d="M12 2.5v3M12 18.5v3M21.5 12h-3M5.5 12h-3M18.4 5.6l-2.1 2.1M7.7 16.3l-2.1 2.1M18.4 18.4l-2.1-2.1M7.7 7.7 5.6 5.6"/></>,
  edit:   <><path d="M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14 7l3 3"/></>,
  trash:  <><path d="M4 7h16M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13"/></>,
  back:   <><path d="M15 5l-7 7 7 7"/></>,
  money:  <><rect x="2.5" y="6" width="19" height="12" rx="2.5"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5v5M18 9.5v5"/></>,
  warn:   <><path d="M12 3 2.5 20h19z"/><path d="M12 10v4M12 17.5v.01"/></>,
  bag:    <><path d="M6 8h12l-1 12H7z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></>,
  star:   <><path d="m12 3 2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 17l-5.2 2.3 1-5.9L3.5 9.2l5.9-.8z"/></>,
  tag:    <><path d="M3 12.5V4h8.5L20 12.5 12.5 20z"/><circle cx="8" cy="8.5" r="1.4"/></>,
  arrow:  <><path d="M5 12h14M13 6l6 6-6 6"/></>,
  info:   <><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 7.5v.01"/></>,
  receipt:<><path d="M5 3h14v18l-2.3-1.4L14.4 21 12 19.6 9.6 21 7.3 19.6 5 21z"/><path d="M9 8h6M9 12h6"/></>,
  play:   <><circle cx="12" cy="12" r="9"/><path d="M10 8.5 16 12l-6 3.5z"/></>,
  phone:  <><path d="M5 3.5h4l2 5-2.5 1.5a11 11 0 0 0 5.5 5.5L15.5 13l5 2v4a1.5 1.5 0 0 1-1.5 1.5A16 16 0 0 1 3.5 5 1.5 1.5 0 0 1 5 3.5z"/></>,
  mail:   <><rect x="3" y="5" width="18" height="14" rx="2.5"/><path d="m3.5 6.5 8.5 7 8.5-7"/></>,
};

export function Icon({ name, size = 22, stroke = 2.1, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round">
      {PATHS[name]}
    </svg>
  );
}
